import { TableBody, TableCell, TableRow } from '@/components/ui/table';
import { v4 as uuid } from 'uuid';
import { EmptyOrLoading } from './empty-or-loading';
import { DatableColumnType, TableBodyPropType } from './type';

const CustomTableCell = ({
  column,
  row,
  isHighlighted = false
}: {
  column: DatableColumnType;
  row: any;
  isHighlighted?: boolean;
}) => {
  const align = column.align || 'left';
  const alignClass =
    align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left';

  // Add highlight class for customerName column when row is highlighted
  const highlightClass = isHighlighted && column.name === 'customerName'
    ? 'bg-blue-100 font-semibold'
    : '';

  if (column.Render) {
    return (
      <TableCell className={`text-sm text-gray-900 ${alignClass} ${highlightClass}`}>
        {column.Render({ data: column.id ? row[column.id!] : null, row, isHighlighted })}
      </TableCell>
    );
  }

  // Get the cell value and ensure it's a valid React node
  const cellValue = row[`${column.name}`];
  const displayValue = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';

  return <TableCell className={`text-sm text-gray-900 ${alignClass} ${highlightClass}`}>{displayValue}</TableCell>;
};

export const EnhancedTableBody = ({
  autoIndex,
  loading,
  tableData,
  columns,
  page,
  rowsPerPage,
  isDisabledTbLoading = true,
  onClickRow,
  highlightedRowId,
}: TableBodyPropType) => {
  const visibleColumns = columns.filter((column) => column.visible !== false);
  const colSpan = visibleColumns.length + (autoIndex ? 1 : 0);

  return (
    <TableBody>
      {tableData?.length
        ? tableData?.map((row: any, numKey: number) => {
          const rowId = String(row.id || row.orderNumber || '');
          // Compare as strings to handle both number and string IDs
          const isHighlighted = highlightedRowId && String(highlightedRowId) === String(rowId);

          return (
            <TableRow
              key={uuid()}
              data-row-id={rowId}
              onClick={(e) => {
                if (onClickRow) {
                  onClickRow(row, e);
                }
              }}
              className={
                isHighlighted
                  ? 'bg-blue-50 border-l-4 border-l-blue-500 hover:bg-blue-100 cursor-pointer'
                  : onClickRow
                    ? 'hover:bg-gray-50 cursor-pointer'
                    : 'hover:bg-gray-50'
              }
            >
              {autoIndex && (
                <TableCell key="autoIndex" className="text-center min-w-[60px] w-[60px]">
                  <span className="text-xs font-semibold text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
                    {rowsPerPage * page + numKey + 1}
                  </span>
                </TableCell>
              )}
              {visibleColumns.map((column: DatableColumnType, colindex: number) => (
                <CustomTableCell
                  key={`${colindex}${column.name}`}
                  column={column}
                  row={row}
                  isHighlighted={isHighlighted || false}
                />
              ))}
            </TableRow>
          );
        })
        : isDisabledTbLoading && <EmptyOrLoading loading={loading} colSpan={colSpan} />}
    </TableBody>
  );
};
